import { connect } from 'react-redux';
import {
  fetchCompany,
  setCompanyForm,
  deleteCompany,
} from '../../../store/modules/company';

import Company from '../components/Company';

const mapActionCreators = {
  fetchCompany,
  setCompanyForm,
  deleteCompany,
};

const mapStateToProps = state => ({
  company: state.company.companies[state.company.current],
  companies: state.company.companies,
  fetching: state.company.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(Company);



// WEBPACK FOOTER //
// ./src/routes/Company/containers/CompanyContainer.js